import { createContext, useContext } from "react";
//#region src/ui/popover/context.tsx
const PopoverContext = createContext(null);
const PopoverContextProvider = PopoverContext.Provider;
/** Returns the current popover compound-component context. Throws outside `Popover.Root`. */
function usePopoverContext() {
	const ctx = useContext(PopoverContext);
	if (!ctx) throw new Error("Popover compound components must be used within a Popover.Root");
	return ctx;
}
//#endregion
export { PopoverContextProvider, usePopoverContext };

//# sourceMappingURL=context.js.map